import React from "react";

import { Button, Col, Modal, Row } from "react-bootstrap";

import classNames from "classnames";
import { ReactSVG } from "react-svg";

import { CheckIcon } from "@assets/icons";

import styles from "./BeneficiarySuccessModel.module.scss";

interface AddBeneficiaryModalProps {
  isOpen: boolean;
  onClose: () => void;
  name: string;
}

export const BeneficiarySuccessModel = ({ isOpen, onClose, name }: AddBeneficiaryModalProps) => {
  return (
    <Modal show={isOpen} size="lg" onHide={onClose}>
      <Modal.Header closeButton />
      <Modal.Body className="p-5">
        <Row className="mt-4 mb-4 text-center">
          <h3>Successful updated {name}’s beneficiaries</h3>
        </Row>
        <Row className="mt-4 mb-4 text-center">
          <div className={classNames(styles["success-icon"])}>
            <div className={classNames(styles["ellipse-108"])}></div>
            <ReactSVG className={classNames(styles["check"])} src={CheckIcon} />
          </div>
        </Row>
        <Row className="mt-4 mb-4 text-center">
          <Col>
            <Button type="submit" onClick={onClose}>
              Close
            </Button>
          </Col>
        </Row>
      </Modal.Body>
    </Modal>
  );
};
